// extracted by mini-css-extract-plugin
export default {"widjet":"Gateways_widjet__0QGuK","iconWrap":"Gateways_iconWrap__3EoIq","overflow":"Gateways_overflow__aiQ18"};